import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import LazyImage from '../common/LazyImage';
// Import map images
import kentuckyMap from '../../assets/images/kentucky-map.jpg';
import kentuckyMapSmall from '../../assets/images/kentucky-map-small.jpg';

const ServiceArea = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  // List of areas served
  const primaryAreas = [
    'Waddy', 'Shelbyville', 'Frankfort', 'Louisville', 'Lexington', 'Lawrenceburg',
    'Taylorsville', 'Mount Eden', 'Simpsonville', 'Finchville'
  ];

  const secondaryAreas = [
    'Spencer County', 'Shelby County', 'Franklin County', 'Jefferson County', 
    'Fayette County', 'Anderson County', 'Bullitt County', 'Henry County'
  ];

  return (
    <section id="service-area" className="service-area-section">
      <div className="container">
        <div className="section-title centered">
          <h2>Our Service Area</h2>
          <p>Serving Central Kentucky Communities</p>
        </div>

        <motion.div 
          className="service-area-content"
          ref={ref}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={fadeIn}
        >
          <div className="service-area-map">
            <LazyImage 
              src={kentuckyMap} 
              alt="Map of Kentucky service area"
              placeholderSrc={kentuckyMapSmall}
            />
            <div className="map-overlay">
              <span>Central Kentucky</span>
            </div>
          </div>

          <div className="service-area-text">
            <p className="lead">
              J&C Renovations proudly serves clients throughout Central Kentucky, with our 
              primary focus in Waddy and surrounding communities.
            </p>
            
            <div className="areas-container">
              <div className="area-column">
                <h3>Primary Service Areas</h3>
                <ul className="area-list">
                  {primaryAreas.map((area, index) => (
                    <li key={index}>{area}</li>
                  ))}
                </ul>
              </div>
              
              <div className="area-column">
                <h3>Counties Served</h3>
                <ul className="area-list">
                  {secondaryAreas.map((area, index) => (
                    <li key={index}>{area}</li>
                  ))}
                </ul>
              </div>
            </div>
            
            <div className="travel-note">
              <h4>Government & Commercial Projects</h4>
              <p>
                For government contracts and larger commercial projects, we're willing to travel 
                beyond our standard service area. Contact us to discuss your specific location needs.
              </p>
            </div>
            
            <div className="service-area-cta">
              <a href="#contact" className="btn btn-primary">Schedule a Consultation</a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ServiceArea;
